import React, { Component } from "react";
import BoatShowsUpdateButton from "./BoatShowsUpdateButton";
import BoatShowsEdit from "./BoatShowsEdit";

export default class BoatShowsUpdate extends Component {
  state = { isEditing: false };

  openEditForm = () => this.setState({ isEditing: true });

  closeEditForm = () => this.setState({ isEditing: false });

  render() {
    // Read the show from props (not a constructor copy) so reopening the
    // form after a save shows the latest values from the live subscription.
    const { boatShows } = this.props;
    return (
      <div style={{ textAlign: "center", padding: 10 }}>
        {this.state.isEditing ? (
          <BoatShowsEdit
            boatShows={boatShows}
            closeEditForm={this.closeEditForm}
          />
        ) : (
          <BoatShowsUpdateButton id={boatShows.id} addClick={this.openEditForm} />
        )}
      </div>
    );
  }
}
